import React from 'react';
import { useState, useEffect } from 'react';
import ApiService from '../../../services/ApiService';
import { Link, useHistory } from 'react-router-dom';

import LoginBySM from '../../../components/Elements/Buttons/socialMediaLogin';
import CustomButtons from '../../../components/Elements/Buttons/customButton';
import CustomInput from '../../../components/Elements/input/customInput';
import CustomLink from '../../../components/Elements/Link/link';
import CustomTittle from '../../../components/Elements/customTittle/customTittle';
import Header from '../../../components/Elements/header/header';
import EDSFooter from '../../../components/EDSFooter';
import Modal from '../../../components/Elements/modal/modal';
import CustomUnderlineText from '../../../components/Elements/underlineText/underlineText';
import RemiandPassword from '../remiandPassword/remiandPassword';
import { setChName } from '../../../reducers/reposReducers';
import { useDispatch } from 'react-redux';
import CourseDetail from '../../coursDetail/courseDetail';
import StepsOfBuy from '../../summary/navigatorBarSummary/stepsOfBuy/stepsOfBuy';
import { API_URL, API_URL_getCourseWWWInfoPortal } from '../../../config';
import {  GoogleLogin, useGoogleLogin } from '@react-oauth/google';
import jwt_decode from "jwt-decode";
import GoogleButton from 'react-google-button'
import './loginBuy.css';
 

const LoginBuy = (props) => {
    
    const [login, setLogin] = useState();
    const [password, setPassword] = useState();
    const history = useHistory();
    const apiService = ApiService.getInstance();
    const stepsList = ['Logowanie', 'Kurs i formalności', 'Podsumowanie'];
    const stepsIndex = 0;
    let [modalClass, showModal] = useState('modal hidden');
    var currentLocation = window.location;
    const courseHeadingNameDispatch = useDispatch();
    const [keyLink, setKeyLink] = useState();
    const [response, setResponse] = useState();
    let today = new Date();
    let day = today.getDate();
    let month = today.getMonth() + 1;
    let year = today.getFullYear();
    if (month < 10) {
        month = '0' + month;
    }
    const startDate = `${year}-${month}-${day}`;
    const [isHiden, setIsHiden] = useState("password")
    
    const [correctResponse, setCorrectResponse] = useState(false);
    const [formDataCamp, setFormDataCourse] = useState({
        productsLevel2:3,
        // attendanceStartDate: `${startDate}`,
        current_LocalizationsID: '0',
        courseHeadingName: keyLink,
    });
    const [formDataCourse] = useState({
        courseHeadingName: keyLink, // 'Żwiry-K1', // TODO będzie przychodić w linku w gecie
        attendanceStartDate: `${startDate}`,
        current_LocalizationsID: '0',
    });
    const [formData, setFromData] = useState({
        login: '',
        password: '',
    });
    const [valid, setValid] = useState({
        login:true,
        password:true,
        wrong:true
    });

    const [header, setHeader] = useState('/  PROCES ZAKUPU KURSU');
    const splitLinkList = currentLocation.href.split('=');
    const dayList = [
        '',
        'Poniedziałek',
        'Wtorek',
        'Środa',
        'Czwartek',
        'Piątek',
        'Sobota',
        'Niedziela',
    ];
    const logIn = () => {
        localStorage.removeItem('participantUsersID');
        
        if (formData.login == '' ) {
            let inputs = document.getElementById('login').children[0].children[1].children;
          

            formData.login = inputs[0].value;
           
        }
        if ( formData.password == '') {
            let inputs = document.getElementById('password').children[0].children[1].children;
           

            
            formData.password = inputs[0].value;
        }
        let timeStemp = new Date().valueOf();
     
        setKey();
        localStorage.setItem('login', formData.login);

        const error = () => {
            history.push('/Login_error');
        };
        if(formData.login !=""&&formData.password !="" ){
            
        apiService.login(formData, (response) => {
            if (response.success) {
                if (response.data.succeeded == 1) {
                    localStorage.setItem('token', response.data.token);

                                        //routingChange
                    // if (
                    //     currentLocation.href.split('/')[6] == undefined ||
                    //     currentLocation.href.split('/')[6] == ''
                    // ) {
                        if (
                            currentLocation.href.split('=')[1] == undefined ||
                            currentLocation.href.split('=')[1] == ''
                        ) {
                           
                                history.push('/Pulpit');
                           

                             
                    } else {
                        if(currentLocation.href.includes("departure")){
                            history.push('/Camp');
                        }else{
                            history.push('/summary');
                        }
                        
                    }
                } else {
                    setValid(
                        {password:true,login:true,wrong:false}
                       )
                }
            } else {
                setValid(
                    {password:true,login:true,wrong:false}
                   )
             
            }
        });}else{
           
            if(formData.password ==""&&formData.login ==""){
                setValid({
                    ...valid, ...{password:false,login:false}
                   })
            }
            if(formData.password !=""&&formData.login ==""){
                setValid({
                    ...valid, ...{password:true,login:false}
                   })
            }
            if(formData.password ==""&&formData.login !=""){
                setValid({
                    ...valid, ...{password:false,login:true}
                   })
            }
        }
    };
    const iconGoogle = (<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="18" height="18" viewBox="0 0 48 48">
    <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"></path><path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"></path><path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"></path><path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"></path>
    </svg>)
    function registerClick() {
        setKey();
        history.push('/Register');
    }

    function changeModal() {
        setKey();
        if (modalClass == 'modal hidden') {
            showModal('modal');
        } else {
            showModal('modal hidden');
        }
    }

    function setKey() {
     
        courseHeadingNameDispatch(setChName(keyLink));
        console.log(keyLink,"key")
              if(keyLink != undefined){
       
        localStorage.setItem('keyURL', keyLink);}
    }
    function reportWindowSize() {
        if(splitLinkList[1]!=undefined && splitLinkList[1].length > 0){
            if (window.innerWidth > 951) {
                if(splitLinkList[1].includes("&")){
                    setHeader('/  PROCES ZAKUPU OBOZU');
                }
                else{
                setHeader('/  PROCES ZAKUPU KURSU');}
            } else {
                if(splitLinkList[1].includes("&")){
                    setHeader('/  ZAKUP OBOZU');
                }else{
                setHeader('/  ZAKUP KURSU');}
            }}else{
                setHeader('');
            }
    }
    function addDays(date, days) {

        date.setDate(date.getDate() + 1);
        return date;
      }

    useEffect(() => {
            let departureName = "";

            if( splitLinkList[1] != undefined) {
                if(splitLinkList[1].includes("?")){
                   
                    let key = splitLinkList[1].split("?")[0]
                    if(key.includes("%20")){
                        key =  key.replaceAll("%20", " ")
                    }
                    formDataCourse.courseHeadingName = key;
                    courseHeadingNameDispatch(setChName(key));
                    localStorage.setItem('keyURL', key)
                    setKeyLink(key);
                }else{
                
                if(splitLinkList[1].includes("&")){
                    
               
                    let key = splitLinkList[1].split("&")[0]
                    if(key.includes("%20")){
                        key =  key.replaceAll("%20", " ")
                    };
                    formDataCourse.courseHeadingName = key;
                    courseHeadingNameDispatch(setChName(key));
                    localStorage.setItem('keyURL', key)
                    setKeyLink(key);
                }else{
                    let key = splitLinkList[1];
                    if(key.includes("%20")){
                        key =  key.replaceAll("%20", " ")
                    }
                    formDataCourse.courseHeadingName = key;
                    localStorage.setItem('keyURL', key)
                    courseHeadingNameDispatch(setChName(key));

                    setKeyLink(key);
                    
                 
                }
                
                }
                
            }else{
                localStorage.removeItem("keyURL")
            }
            if( splitLinkList[2] != undefined&&currentLocation.href.includes("departure")){
                if(splitLinkList[2].includes("?")){
                    
                    let departureWitheOutQuestionMark = splitLinkList[2].split("?")[0];
                    departureName = departureWitheOutQuestionMark
                    localStorage.setItem("departure",departureWitheOutQuestionMark)
                }else{
                    departureName = splitLinkList[2]
                    localStorage.setItem("departure",splitLinkList[2])
                }
            }
  
        
        if (formDataCourse.courseHeadingName != undefined && formDataCourse.courseHeadingName.length !=0) {
            formDataCamp.courseHeadingName = formDataCourse.courseHeadingName
            let urlApi = `${API_URL_getCourseWWWInfoPortal}getCourseWWWInfoPortal`
            let jsonBody;
          
            if(departureName == ""){
            
                 jsonBody = formDataCourse
            
            }
            else{
             jsonBody = formDataCamp
            }
            
            fetch(
                `${urlApi}`,
                {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: null,
                    },
                    body: JSON.stringify(jsonBody),
                }
            )
                .then((response) => {
                  
                    return response.json();
                })
                .then((response) => {
            if(departureName == ""){
                    localStorage.setItem('courseHeadingFull', JSON.stringify(response.body));
                    localStorage.setItem('danceStyle', response.body.courseDanceStyle);
                    localStorage.setItem('courseTime', response.body.courseTime);
                    localStorage.setItem('frequency', response.body.Frequency);
                    localStorage.setItem('courseLevel', response.body.courseLevel);
                    localStorage.setItem('courseAgeRanges', response.body.courseAgeRanges);
                    localStorage.setItem('localizationName', response.body.localizationName);
                    localStorage.setItem('instructorsList', response.body.instructorsList);
                    localStorage.setItem('localizationName', response.body.localizationName);
                    localStorage.setItem('eventDate', response.body.eventDate);
                    localStorage.removeItem('campHeadingFull');
                    setCorrectResponse(true)}else{
                        localStorage.removeItem('courseHeadingFull');
                        localStorage.setItem('campHeadingFull', JSON.stringify(response.body));
                        setCorrectResponse(true) 
                    }
                   
                });
        } else {
            setCorrectResponse(false);
            localStorage.removeItem('courseHeadingFull');
            localStorage.removeItem('campHeadingFull');
            localStorage.removeItem('danceStyle');
            localStorage.removeItem('courseTime');
            localStorage.removeItem('frequency');
            localStorage.removeItem('courseLevel');
            localStorage.removeItem('courseAgeRanges');
            localStorage.removeItem('localizationName');
            localStorage.removeItem('instructorsList');
            localStorage.removeItem('localizationName');
            localStorage.removeItem('eventDate');
           
        }
    }, [currentLocation.href]);
    function loginByGoogle (response){
        console.log(response)
    }
    useEffect(() => {
         
        reportWindowSize();
        document.getElementById('loginColumn').addEventListener('keypress', function (e) {     
            if (e.key === 'Enter') {
                logIn();
            }
        });

        window.google.accounts.id.initialize({
        client_id:"521507719932-uifbl2noql12c04rmdj4j52pum20hbsv.apps.googleusercontent.com",
        callback: loginByGoogle
    })
    // google.account.id.renderButton(
    //     document.getElementById("googleSignIn")
    // )
    }
    , []);

    window.onresize = reportWindowSize;
    
    function changeViewCharacter (){
        if(isHiden == "password"){
        setIsHiden("")}else{
            setIsHiden("password") 
        }
    }

        const googleSingIn = useGoogleLogin({
            onSuccess: codeResponse => console.log(codeResponse)
          });
    return (
        <>
            <div className={modalClass}>
                <Modal close={changeModal}>
                    <RemiandPassword modalState={modalClass} closeModal={changeModal}></RemiandPassword>
                </Modal>
            </div>
            <Header isNeedLogutIcon={false}>{header}</Header>
            <div className="content">
            {/* routingChange */}
            {/* {splitLinkList[7]!=undefined && splitLinkList[7].length > 0?<StepsOfBuy choosen={stepsIndex} stepsList={stepsList}></StepsOfBuy>:""} */}
            {splitLinkList[1]!=undefined && !currentLocation.href.includes("departure") && splitLinkList[1].length > 0?<StepsOfBuy choosen={stepsIndex} stepsList={stepsList}></StepsOfBuy>:""}
            <div className="rowSection">
                <div className="column" id="loginColumn">
                    <CustomTittle>Zaloguj się </CustomTittle>
                    <div id="login">
                    <CustomInput
                        isRequied={true}
                        onChangeInput={(e) => {
                            setFromData({
                                ...formData,
                                ...{ login: e },
                            });
                            setValid({
                                ...valid, ...{login:true}
                               })
                        }}
                        title="E-mail"
                    ></CustomInput>
                     {valid.login?"":<div className="msgInvalid">*Pole e-mail musi być uzupełnione</div>}
                    </div><div id="password">
                    <CustomInput
                        type={isHiden}
                        title="Hasło"
                        isRequied={true}
                        onChangeInput={(e) => {
                            setFromData({
                                ...formData,
                                ...{ password: e },
                            });
                            setValid({
                                ...valid, ...{password:true}
                               })
                        }}
                        icon={isHiden == "password"?<svg onClick={changeViewCharacter} width="22" height="22" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 11C4.80285 11 2.52952 9.62184 1.09622 7.50001C2.52952 5.37816 4.80285 4 7.5 4C10.1971 4 12.4705 5.37816 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11ZM7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C1.65639 10.2936 4.30786 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C13.3436 4.70638 10.6921 3 7.5 3ZM7.5 9.5C8.60457 9.5 9.5 8.60457 9.5 7.5C9.5 6.39543 8.60457 5.5 7.5 5.5C6.39543 5.5 5.5 6.39543 5.5 7.5C5.5 8.60457 6.39543 9.5 7.5 9.5Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"></path></svg>:
                        <svg onClick={changeViewCharacter} width="22" height="22" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.6828 3.61012C9.70652 3.21671 8.63759 3 7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C0.902945 9.08812 2.02314 10.1861 3.36061 10.9323L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.31723 11.3899C5.29348 11.7833 6.36241 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C14.0971 5.9119 12.9769 4.81391 11.6394 4.06771L13.3536 2.35355ZM9.90428 4.38861C9.15332 4.1361 8.34759 4 7.5 4C4.80285 4 2.52952 5.37816 1.09622 7.50001C1.87284 8.6497 2.89609 9.58106 4.09974 10.1931L9.90428 4.38861ZM5.09572 10.6114L10.9003 4.80685C12.1039 5.41894 13.1272 6.35031 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11C6.65241 11 5.84668 10.8639 5.09572 10.6114Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"></path></svg>}
                    ></CustomInput>
                     {valid.password?"":<div className="msgInvalid">*Pole hasło musi być uzupełnione</div>}
</div>
{valid.wrong?"":<div className="msgInvalid">*Podany e-mail lub hasło jest niepoprawne</div>}
                    <div className="button_section">
                        <CustomButtons
                            isMargin={true}
                            clickFunction={logIn}
                            classButton="solid"
                            size="big"
                        >
                            ZALOGUJ SIĘ
                        </CustomButtons>
                        <div className="custom-google-button" id="googleButtons">
                        {/* <GoogleLogin
                            render={renderProps => (
                                <GoogleButton onClick={renderProps.onClick} disabled={renderProps.disabled}>Sign in with Google</GoogleButton>
                            )}
                            onSuccess={credentialResponse => {
                                console.log(credentialResponse.credential);
                                let responseDecode =  jwt_decode(credentialResponse.credential)
                                console.log(responseDecode)
                            }}
                            onError={() => {
                                console.log('Login Failed');
                            }}
                            cookiePolicy={'single_host_origin'}
                        /> */}
                        </div>
                       
                        <div className='forWho'>Jesteś już klientem Egurrola Dance Studio<p title="Twój adres e-mail jest już w naszej bazie, przypomnij hasło i zaloguj się na Twoje konto" className='hintTextDot'>?</p></div>
                        
                        <CustomUnderlineText size="big" clickFunction={changeModal}>
                            Przypomnij hasło
                        </CustomUnderlineText>
                       
                        {/* <LoginBySM smallLabel="Zaloguj się przez Google" icon={iconGoogle} size="big" click={(e)=>{e.preventDefault();googleSingIn()}}>Zaloguj się używając konta Google</LoginBySM> */}
               
                        <p>lub</p>
                        <CustomButtons
                            clickFunction={registerClick}
                            classButton="outline"
                            size="big"
                        >
                            ZAŁÓŻ KONTO
                        </CustomButtons>
                    </div>
                </div>
                <div className="columDetials">
                    {/* routingChange */}
                   
                    {                        
                    // currentLocation.href.split('/')[6] != '' &&
                    // currentLocation.href.split('/')[6] != undefined&&localStorage.getItem('danceStyle') != null
                    // currentLocation.href.split('/')[5] != '' &&
                    // currentLocation.href.split('/')[5] != undefined&&localStorage.getItem('danceStyle') != null 
                    currentLocation.href.split('=')[1] != '' &&
                    currentLocation.href.split('=')[1] != undefined&&(localStorage.getItem('danceStyle') != null||localStorage.getItem('campHeadingFull') != null) 
                    ? (
                        <div className="columDetials_wrapper">
                            <CustomTittle>Szczegóły zamówienia </CustomTittle>
                            <CourseDetail
                                tittle="login"
                                setHeader={setHeader}
                                header={header}
                            ></CourseDetail>
                        </div>
                    ) : (
                        ''
                    )}
                </div></div>
            </div>
            {/* <div  style={{ marginTop: '50px' }}>
                <EDSFooter></EDSFooter>
            </div> */}
        </>
    );
};

export default LoginBuy;
